<template>
  <div class="border-top reply-message">
    <v-layout row wrap class="ma-0">
      <v-flex md11 xs10>
        <textarea
          v-model="replyMessage"
          name="message"
          class="thread-body__textarea"
          placeholder="Enter the message"
          @keyup.enter="sendMessage"
        />
      </v-flex>
      <v-flex md1 xs1 offset-xs1 offset-md0>
        <v-icon :color="sendIconColor" @click="sendMessage">
          send
        </v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import colors from '../../scss/_colors.scss'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      colors: colors,
      replyMessage: ''
    }
  },
  computed: {
    ...mapState('common', ['isMobile']),
    sendIconColor() {
      if (this.replyMessage.length) {
        return colors.hwayzBrandBlue
      }
      return colors.hwayzMediumGray
    }
  },
  methods: {
    sendMessage() {
      if (this.replyMessage.length) {
        this.$emit('on-submit', this.replyMessage)
        this.replyMessage = ''
      }
    }
  }
}
</script>

<style lang="sass">
.reply-message__text
  @media only screen and (max-width: 600px)
    .v-input__slot
      border: none !important
      height: 30px !important
    label
      font-size: 12px
      top: 0 !important
    textarea
      margin-top: 0 !important
      font-size: 12px !important

textarea
  width: 100%
  resize: none

textarea:focus,
input:focus
  outline: none
.reply-message
  background: #fff
  padding: 2rem
  @media only screen and (max-width: 600px)
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    height: 80px

  &__button
    background-color: $hwayzMediumGray !important
    border-radius: 1rem
    height: 3.5rem
    margin-right: 0
    padding-left: 2rem
    padding-right: 2rem
    margin-bottom: 3rem
    color: #fff !important

.mobile-message-input
  border: 1px solid #c2c2c2
  border-radius: 0.5rem
  padding: 3px 5px
  input
    width: 100%
    display: block
</style>
